import { StyleSheet, Font } from "@react-pdf/renderer";
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Me5Q.ttf",
      fontWeight: "normal",
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmWUlvAw.ttf",
      fontWeight: "bold",
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    color: "#262626",
    fontFamily: "Roboto",
    fontSize: "12px",
    padding: "30px 50px",
    borderRadius: "8px",
  },
  header: {
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: 20,
  },
  date: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  title: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  image: {
    width: 180,
    height: 60,
  },
  imageContainer: {
    width: 180,
    height: 60,
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  textBold: {
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  text: {
    maxWidth: "95%",
  },
  subtext: {
    maxWidth: "92%",
  },
  spaceY: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    letterSpacing: 0.1,
    lineHeight: 1.3,
    textAlign: "justify",
  },
  spaceX: {
    display: "flex",
    flexDirection: "row",
    gap: "4px",
  },

  subListItem: {
    marginLeft: 24,
    letterSpacing: -0.1,
  },
  link: {
    color: "#007FFF",
    textDecoration: "underline",
  },
});
